import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "otp-dialog__header" }
const _hoisted_2 = { class: "otp-dialog__title" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "otp-dialog__content" }
const _hoisted_5 = { class: "otp-dialog__info" }
const _hoisted_6 = { class: "otp-dialog__message" }
const _hoisted_7 = { class: "otp-dialog__project-name" }
const _hoisted_8 = { class: "otp-dialog__input-section" }
const _hoisted_9 = {
  for: "otpCode",
  class: "otp-dialog__label"
}
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "otp-dialog__error"
}
const _hoisted_12 = { class: "otp-dialog__footer" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  class: "spinning"
}
const _hoisted_16 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "otp-dialog-overlay",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.handleOverlayClick && $setup.handleOverlayClick(...args)))
      }, [
        _createElementVNode("div", {
          class: "otp-dialog",
          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('notifications.verifyAccess')), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleClose && $setup.handleClose(...args))),
              class: "otp-dialog__close-btn",
              title: _ctx.$t('common.close'),
              type: "button"
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                width: "20",
                height: "20"
              }, [
                _createElementVNode("path", {
                  fill: "currentColor",
                  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                })
              ], -1)
            ]))], 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "otp-dialog__icon" }, [
                _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  width: "24",
                  height: "24"
                }, [
                  _createElementVNode("path", {
                    fill: "currentColor",
                    d: "M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M10,17L6,13L7.41,11.59L10,14.18L16.59,7.59L18,9L10,17Z"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('notifications.otpInstructions')), 1),
                _createElementVNode("p", _hoisted_7, [
                  _createElementVNode("strong", null, _toDisplayString($props.notification?.data?.projectName), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('notifications.securityCode')), 1),
              _withDirectives(_createElementVNode("input", {
                id: "otpCode",
                ref: "otpInput",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.otpCode) = $event)),
                type: "text",
                class: _normalizeClass(["otp-dialog__input", { 'otp-dialog__input--error': !!$setup.errorMessage }]),
                placeholder: _ctx.$t('notifications.enterCodePlaceholder'),
                maxlength: "6",
                autocomplete: "off",
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleOtpInput && $setup.handleOtpInput(...args))),
                onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => ($setup.handleVerify && $setup.handleVerify(...args)), ["enter"]))
              }, null, 42, _hoisted_10), [
                [_vModelText, $setup.otpCode]
              ]),
              ($setup.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.errorMessage), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.handleClose && $setup.handleClose(...args))),
              class: "app-button app-button--outline",
              type: "button",
              disabled: $props.isLoading
            }, _toDisplayString(_ctx.$t('common.cancel')), 9, _hoisted_13),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.handleVerify && $setup.handleVerify(...args))),
              class: "app-button app-button--success",
              type: "button",
              disabled: !$setup.otpCode.trim() || $props.isLoading
            }, [
              ($props.isLoading)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("path", {
                      fill: "currentColor",
                      d: "M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                    }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_16, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("path", {
                      fill: "currentColor",
                      d: "M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"
                    }, null, -1)
                  ]))])),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('notifications.verify')), 1)
            ], 8, _hoisted_14)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}